import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import {
  electricityBasisUnitsGridRate,
  waterBasisUnitsBoard,
  gasBasisUnitsGasBank,
  hvacBasisFlatUnitRate,
  hvacBasisBtuUnitRate,
  extraHoursChargesBasisFlatRate,
  horticultureChargesFlatRate,
} from "../../constants";
import { Modal, Button } from "react-bootstrap";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
import { getToDate } from "../../utils/utils";
class Utilities extends React.Component {
  countError = "";
  state = {
    note_val: "",
    disableOnEdit: false,
    currentIndex: null,
    showFirstAddBtn: true,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupData: {},
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    from: "",
    to: "",
    isOpen: false,
    leaseTermYY: "",
    leaseTermMM: "",
    leaseTermDD: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    redirect: false,
    utilities: [],
    utilityRateUomValues: [],
    initialValues: {
      utilityLogic: {
        utilityType: "",
        utilityUom: "",
        onArea: "",
        invoicePeriod: "",
        applicableFrom: "",
        applicableFromDate: "",
        dueDate: "",
        dueType: "",
        dueFrequency: "",
        rates: [],
        subCategoryTypes: "",
      },
    },
    
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {
    console.log(this.props, "props");
  }

  addRatesRow = () => {
    if (this.state.initialValues.utilityLogic.rates === undefined) {
      this.state.initialValues.utilityLogic.rates = [];
    }
    this.state.initialValues.utilityLogic.rates.push({
      from: "",
      to: "",
      rate: "",
    });
    if (this.state.initialValues.utilityLogic.rates.length > 0) {
      this.setState({ showFirstAddBtn: false });
    }
    this.setState({});
  };

  getFromForNextSlab(e, values, index) {
    this.state.initialValues.utilityLogic.rates[index + 1].from = getToDate(
      e.target.value,
      2,
      0,
      0
    );
    this.setState({});
  }

  removeRatesRow(element) {
    this.state.initialValues.utilityLogic.rates.splice(element, 1);
    if (this.state.initialValues.utilityLogic.rates.length == 0) {
      this.setState({ showFirstAddBtn: true });
    }
    this.setState({});
  }

  editUtility(index, values) {
    console.log(this.state.utilities[index]);
    this.state.currentIndex = index;
    this.state.disableOnEdit = true;

    if (this.state.utilities[index].utility.rates === undefined) {
      this.state.showFirstAddBtn = true;
    } else {
      this.state.showFirstAddBtn = false;
    }

    this.state.period = this.state.utilities[index].period;
    this.state.initialValues.totalSlabs =
      this.state.utilities[index].slabNumber;
    // this.loadUtilityUomValues(this.state.utilities[index].utility.utilityUom);
    if (
      this.state.utilities[index].utility.utilityType ===
      "Electricity Basis Units @ Grid Rate" ||
      this.state.utilities[index].utility.utilityType ===
      "Electricity Basis Units @ DG" ||
      this.state.utilities[index].utility.utilityType ===
      "Electricity Basis Units @ Solar" ||
      this.state.utilities[index].utility.utilityType ===
      "Electricity Basis Units @ Other Sources" ||
      this.state.utilities[index].utility.utilityType ===
      "Electricity Basis Units @ Blendid"
    ) {
      this.setState({
        utilityRateUomValues: electricityBasisUnitsGridRate,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "Water Basis Units @ Board" ||
      this.state.utilities[index].utility.utilityType ===
      "Water Basis Units @ Other Sources"
    ) {
      this.setState({
        utilityRateUomValues: waterBasisUnitsBoard,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "Gas Basis Units @ Gas Bank" ||
      this.state.utilities[index].utility.utilityType ===
      "Gas Basis Units @ Piped Gas Bank"
    ) {
      this.setState({
        utilityRateUomValues: gasBasisUnitsGasBank,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "HVAC Basis Flat Unit Rate" ||
      this.state.utilities[index].utility.utilityType === "Other"
    ) {
      this.setState({
        utilityRateUomValues: hvacBasisFlatUnitRate,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "HVAC Basis BTU Unit Rate"
    ) {
      this.setState({
        utilityRateUomValues: hvacBasisBtuUnitRate,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "CAM During Fitout Period"
    ) {
      this.setState({
        utilityRateUomValues: hvacBasisFlatUnitRate,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "Extra Hours Charges Basis Flat Rate"
    ) {
      this.setState({
        utilityRateUomValues: extraHoursChargesBasisFlatRate,
      });
    } else if (
      this.state.utilities[index].utility.utilityType ===
      "Horticulture Charges Flat Rate" ||
      this.state.utilities[index].utility.utilityType ===
      "MEP Services Flat Rate"
    ) {
      this.setState({
        utilityRateUomValues: horticultureChargesFlatRate,
      });
    } else {
      this.setState({
        utilityRateUomValues: [],
      });
    }
    this.setState({});
    values.utilityLogic.utilityType =
      this.state.utilities[index].utility.utilityType;
    values.utilityLogic.utilityUom =
      this.state.utilities[index].utility.utilityUom;
    values.utilityLogic.onArea = this.state.utilities[index].utility.onArea;
    values.utilityLogic.invoicePeriod =
      this.state.utilities[index].utility.invoicePeriod;
    values.utilityLogic.applicableFrom =
      this.state.utilities[index].utility.applicableFrom;
    values.utilityLogic.dueDate = this.state.utilities[index].utility.dueDate;
    values.utilityLogic.dueType = this.state.utilities[index].utility.dueType;
    values.utilityLogic.dueFrequency =
      this.state.utilities[index].utility.dueFrequency;
    values.utilityLogic.applicableFromDate =
      this.state.utilities[index].utility.applicableFromDate;
    values.utilityLogic.rates = this.state.utilities[index].utility.rates;
    if (this.state.utilities[index].utility.utilityType == "Other") {
      console.log("pp");
      values.utilityLogic.subCategoryTypes =
        this.state.utilities[index].utility.subCategoryTypes;
    }
    this.state.fromDate = this.state.utilities[index].fromDate;
    this.state.toDate = this.state.utilities[index].toDate;
    this.setState({});
  }

  addUtilityDetails = (values) => {
    if (this.state.currentIndex === null) {
      console.log(values);
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      var _utilities = this.state.utilities;
      _utilities.push({
        utility: values.utilityLogic,
        utilityRateUomValues: this.state.utilityRateUomValues,
      });
      this.setState({
        utilities: _utilities,
        showFirstAddBtn: true,
        initialValues: {
          utilityLogic: {
            utilityType: "",
            utilityUom: "",
            invoicePeriod: "",
            applicableFrom: "",
            applicableFromDate: "",
            dueDate: "",
            dueType: "",
            dueFrequency: "",
            rates: [],
          },
        },
      });
      var _initialValues = this.state.initialValues;
      _initialValues.utilityLogic = {};
      this.validator.hideMessages();
      this.setState({});
      if (this.state.utilities.length > 0) {
        this.mainFormValidator.hideMessages();
      }
    } else {
      console.log("Notnull");
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      var _utilities = this.state.utilities;

      console.log(values.utilityLogic);
      _utilities[this.state.currentIndex].utility = { ...values.utilityLogic };
      console.log(this.state.utilities);
      this.setState({
        utilities: _utilities,
        showFirstAddBtn: true,
        initialValues: {
          utilityLogic: {
            utilityType: "",
            utilityUom: "",
            invoicePeriod: "",
            applicableFrom: "",
            applicableFromDate: "",
            dueDate: "",
            dueType: "",
            dueFrequency: "",
            rates: [],
          },
        },
      });
      var _initialValues = this.state.initialValues;
      _initialValues.utilityLogic = {};
      this.validator.hideMessages();
      this.state.currentIndex = null;
      this.setState({});
      if (this.state.utilities.length > 0) {
        this.mainFormValidator.hideMessages();
      }
    }
  };

  resetUtilityDetails = (values) => {
    this.setState({
      // utilities: _utilities,
      showFirstAddBtn: true,
      initialValues: {
        utilityLogic: {
          utilityType: "",
          utilityUom: "",
          invoicePeriod: "",
          applicableFrom: "",
          applicableFromDate: "",
          dueDate: "",
          dueType: "",
          dueFrequency: "",
          rates: [],
        },
      },
    });
    var _initialValues = this.state.initialValues;
    _initialValues.utilityLogic = {};
    this.validator.hideMessages();
    this.state.currentIndex = null;
    this.setState({});
    if (this.state.utilities.length > 0) {
      this.mainFormValidator.hideMessages();
    }
  };

  loadUtilityUomValues(e) {
    if (
      e.target.value === "Electricity Basis Units @ Grid Rate" ||
      e.target.value === "Electricity Basis Units @ DG" ||
      e.target.value === "Electricity Basis Units @ Solar" ||
      e.target.value === "Electricity Basis Units @ Other Sources" ||
      e.target.value === "Electricity Basis Units @ Blendid"
    ) {
      this.setState({
        utilityRateUomValues: electricityBasisUnitsGridRate,
      });
    } else if (
      e.target.value === "Water Basis Units @ Board" ||
      e.target.value === "Water Basis Units @ Other Sources"
    ) {
      this.setState({
        utilityRateUomValues: waterBasisUnitsBoard,
      });
    } else if (
      e.target.value === "Gas Basis Units @ Gas Bank" ||
      e.target.value === "Gas Basis Units @ Piped Gas Bank"
    ) {
      this.setState({
        utilityRateUomValues: gasBasisUnitsGasBank,
      });
    } else if (
      e.target.value === "HVAC Basis Flat Unit Rate" ||
      e.target.value === "Other"
    ) {
      this.setState({
        utilityRateUomValues: hvacBasisFlatUnitRate,
      });
    } else if (e.target.value === "HVAC Basis BTU Unit Rate") {
      this.setState({
        utilityRateUomValues: hvacBasisBtuUnitRate,
      });
    } else if (e.target.value === "CAM During Fitout Period") {
      this.setState({
        utilityRateUomValues: hvacBasisFlatUnitRate,
      });
    } else if (e.target.value === "Extra Hours Charges Basis Flat Rate") {
      this.setState({
        utilityRateUomValues: extraHoursChargesBasisFlatRate,
      });
    } else if (
      e.target.value === "Horticulture Charges Flat Rate" ||
      e.target.value === "MEP Services Flat Rate"
    ) {
      this.setState({
        utilityRateUomValues: horticultureChargesFlatRate,
      });
    } else {
      this.setState({
        utilityRateUomValues: [],
      });
    }
  }

  componentDidMount() {

    let athis= this;
    axios({
      url:`${apiUrl.apiUrl.url}/create-lease/fetch-lease-utilities?id=${this.props.match.params.id}`,
      method: 'GET',
    }).then(function(response){
      let data = response.data;
      athis.state.from = data.from;
      athis.state.to = data.to;

      athis.setState({
        utilities: data.utilities,
        renewalLeaseTermDD: data.renewalLeaseTermDD,
        renewalLeaseTermMM: data.renewalLeaseTermMM,
        renewalLeaseTermYY: data.renewalLeaseTermYY,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        initialValues: {
          ...athis.state.initialValues, // Preserve other initial values
          notes_7: data.notes_7 || "", // Ensure notes_7 is updated properly
        }
      });

      //athis.setState({ 'note_val' : data.notes_7 });
      var initialValues = athis.state.initialValues;
      initialValues["notes_7"] = data.notes_7;

      athis.setState({ initialValues: initialValues });

      console.log(initialValues, "initialValues initialValues");
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-utilities?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.from = data.from;
    //     this.state.to = data.to;

    //     this.setState({
    //       utilities: data.utilities,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //     });

    //     //this.setState({ 'note_val' : data.notes_7 });
    //     var initialValues = this.state.initialValues;
    //     initialValues["notes_7"] = data.notes_7;

    //     this.setState({ initialValues: initialValues });

    //     console.log(initialValues, "initialValues initialValues");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _mf = this.state.utilities;
    _mf.splice(this.state.index_val, 1);
    console.log(_mf, "new array");
    this.setState({
      utilities: _mf,
    });
    this.setState({
      delete: false,
      index_val: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/marketing-fund/" + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Other Charges</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Utilities</a>
                  </li>
                </ul>
              </div>
            </div>

            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                if (this.state.utilities.length == 0) {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                values.utilities = this.state.utilities;
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-utilities?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off">
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Lease Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">

                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-4 p-0">

                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                    onChange={(e) => {
                                      this.state.renewalLeaseTermYY = e.target.value;
                                      handleChange(e);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                    onChange={(e) => {
                                      this.state.renewalLeaseTermMM = e.target.value;
                                      handleChange(e);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                    onChange={(e) => {
                                      this.state.renewalLeaseTermDD = e.target.value;
                                      handleChange(e);
                                    }}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>From</label>
                            <div className="position-relative">
                              <Field
                                type="date"
                                name="from"
                                value={this.state.from}
                              />
                              <ErrorMessage
                                name="from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>To</label>
                            <div className="position-relative">
                              <Field
                                type="date"
                                name="to"
                                value={this.state.to}
                              />
                              <ErrorMessage
                                name="to"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Utility Type</label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="utilityLogic.utilityType"
                                onChange={(e) => {
                                  handleChange(e);
                                  this.loadUtilityUomValues(e);
                                }}
                              >
                                <option
                                  value=""
                                  label="Select"
                                  defaultValue
                                />
                                <option
                                  value="Electricity Basis Units @ Grid Rate"
                                  label="Electricity Basis Units @ Grid Rate"
                                />
                                <option
                                  value="Electricity Basis Units @ DG"
                                  label="Electricity Basis Units @ DG"
                                />
                                <option
                                  value="Electricity Basis Units @ Solar"
                                  label="Electricity Basis Units @ Solar"
                                />
                                <option
                                  value="Electricity Basis Units @ Other Sources"
                                  label="Electricity Basis Units @ Other Sources"
                                />
                                <option
                                  value="Electricity Basis Units @ Blendid"
                                  label="Electricity Basis Units @ Blendid"
                                />
                                <option
                                  value="Water Basis Units @ Board"
                                  label="Water Basis Units @ Board"
                                />
                                <option
                                  value="Water Basis Units @ Other Sources"
                                  label="Water Basis Units @ Other Sources"
                                />
                                <option
                                  value="Gas Basis Units @ Gas Bank"
                                  label="Gas Basis Units @ Gas Bank"
                                />
                                <option
                                  value="Gas Basis Units @ Piped Gas Bank"
                                  label="Gas Basis Units @ Piped Gas Bank"
                                />
                                <option
                                  value="HVAC Basis Flat Unit Rate"
                                  label="HVAC Basis Flat Unit Rate"
                                />
                                <option
                                  value="HVAC Basis BTU Unit Rate"
                                  label="HVAC Basis BTU Unit Rate"
                                />
                                <option
                                  value="Extra Hours Charges Basis Flat Rate"
                                  label="Extra Hours Charges Basis Flat Rate"
                                />
                                <option
                                  value="Horticulture Charges Flat Rate"
                                  label="Horticulture Charges Flat Rate"
                                />
                                <option
                                  value="MEP Services Flat Rate"
                                  label="MEP Services Flat Rate"
                                />
                                <option
                                  value="CAM During Fitout Period"
                                  label="CAM During Fitout Period"
                                />
                                <option value="Other" label="Other" />
                              </Field>
                              {this.validator.message(
                                "utility Type",
                                values.utilityLogic.utilityType,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Utility UOM</label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="utilityLogic.utilityUom"
                                onChange={(e) => {
                                  
                                  this.validator = new SimpleReactValidator({
                                    autoForceUpdate: this,
                                  });
                                  handleChange(e);
                                  console.log(values);
                                }}
                              >
                                <option
                                  value=""
                                  label="Select"
                                  defaultValue
                                />
                                {this.state.utilityRateUomValues.map(
                                  (item, i) => (
                                    <option
                                      key={"utilityRateUomValues" + item}
                                      value={item}
                                    >
                                      {item}
                                    </option>
                                  )
                                )}
                              </Field>
                              {this.validator.message(
                                "Utility UOM",
                                values.utilityLogic.utilityUom,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          {values.utilityLogic.utilityUom === "Per Sq Ft" && (
                            <div className="newGridSectionInner">
                              <label>
                                on Area <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"utilityLogic.onArea"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="Usable Area" label="Usable Area" />
                                  <option value="Carpet Area" label="Carpet Area" />
                                  <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                </Field>
                                {this.validator.message(
                                  "On Area",
                                  values.utilityLogic.onArea,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                          )}

                          <div className="newGridSectionInner">
                            <label>Utility Invoice Period</label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="utilityLogic.invoicePeriod"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option
                                  value=""
                                  label="Select"
                                  defaultValue
                                />
                                <option
                                  value="Per Day"
                                  label="Per Day"
                                ></option>
                                <option
                                  value="Per Month"
                                  label="Per Month"
                                ></option>
                                <option
                                  value="Per Quarter"
                                  label="Per Quarter"
                                ></option>
                                <option
                                  value="Per Year"
                                  label="Per Year"
                                ></option>
                              </Field>
                              {this.validator.message(
                                "Utility Invoice Period",
                                values.utilityLogic.invoicePeriod,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Applicable From <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="utilityLogic.applicableFrom"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option
                                  value=""
                                  label="Select"
                                  defaultValue
                                />
                                <option
                                  value="Fitout Letter Date"
                                  label="Fitout Letter Date"
                                ></option>
                                <option
                                  value="Lease Commencement Date"
                                  label="Lease Commencement Date"
                                ></option>
                                <option
                                  value="Rent Commencement Date"
                                  label="Rent Commencement Date"
                                ></option>
                                <option
                                  value="Other Date"
                                  label="Other Date"
                                ></option>
                              </Field>
                              {this.validator.message(
                                "Applicable From",
                                values.utilityLogic.applicableFrom,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Due Date <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-6 ps-0">
                                  <Field
                                    type="number"
                                    name={"utilityLogic.dueDate"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6 pe-0">
                                  <Field
                                    as="select"
                                    name={"utilityLogic.dueType"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option value="" label="Select" defaultValue />
                                    <option value="Date" label="Date" />
                                    <option value="Days" label="Days" />
                                    <option value="Working Day" label="Working Day" />
                                  </Field>
                                </div>
                                <div className="col-sm-12 p-0 mt-3">
                                  <Field
                                    as="select"
                                    name={"utilityLogic.dueFrequency"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Every Month"
                                      label="Every Month"
                                    />
                                    <option
                                      value="Subsequent Month"
                                      label="Subsequent Month"
                                    />
                                    <option
                                      value="Subsequent Quarter"
                                      label="Subsequent Quarter"
                                    />
                                    <option
                                      value="Subsequent Half Year"
                                      label="Subsequent Half Year"
                                    />
                                    <option
                                      value="Subsequent Year"
                                      label="Subsequent Year"
                                    />
                                    <option
                                      value="Next Financial Year"
                                      label="Next Financial Year"
                                    />
                                  </Field>
                                </div>
                              </div>
                              {this.validator.message(
                                "Due Date",
                                values.utilityLogic.dueDate,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Applicable From Date <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type="date"
                                name="utilityLogic.applicableFromDate"
                              />
                              {this.validator.message(
                                "Applicable From",
                                values.utilityLogic.applicableFromDate,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          {values.utilityLogic.utilityType === "Other" && (
                            <div className="newGridSectionInner">
                              <label>Sub Category Type</label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="utilityLogic.subCategoryTypes"
                                />
                                <ErrorMessage
                                  name="utilityLogic.subCategoryTypes"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          )}

                          {this.state.showFirstAddBtn == true && (
                            <div className="gridColOneByThree">
                              {/* <div className="col-lg-12 p-0 text-end"> */}
                              <div className="button_group d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="add_button"
                                  onClick={(e) => {
                                    this.addRatesRow();
                                  }}
                                >
                                  Add Rates
                                </button>
                                {/* </div> */}
                              </div>
                            </div>
                          )}

                          {this.state.initialValues.utilityLogic.rates != undefined && (
                            <>
                              <div className="gridColOneByThree">
                                <hr />
                              </div>
                              {this.state.initialValues.utilityLogic.rates.map((name, index) => (
                                <>

                                  <div className="newGridSectionInner">
                                    <label>From</label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name={`utilityLogic.rates.${index}.from`}
                                        onChange={(e) => {
                                          this.state.initialValues.utilityLogic.rates[index].from = e.target.value;
                                          handleChange(e);
                                        }}
                                        value={this.state.initialValues.utilityLogic.rates[index].from}
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>To</label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name={`utilityLogic.rates.${index}.to`}
                                        onChange={(e) => {
                                          this.state.initialValues.utilityLogic.rates[index].to = e.target.value;
                                          handleChange(e);
                                        }}
                                        value={this.state.initialValues.utilityLogic.rates[index].to}
                                        onBlur={(e) => {
                                          if (
                                            index <
                                            this.state.initialValues.utilityLogic.rates.length - 1
                                          ) {
                                            this.getFromForNextSlab(e, values, index);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>{values.utilityLogic.utilityUom && values.utilityLogic.utilityUom === "Flat Amount"? "Flat Amount": "Rate"}</label>
                                    <div className="position-relative d-flex gap-2 align-items-center">
                                      <Field
                                        type="text"
                                        name={`utilityLogic.rates.${index}.rate`}
                                        onChange={(e) => {
                                          this.state.initialValues.utilityLogic.rates[index].rate = e.target.value;
                                          handleChange(e);
                                        }}
                                        value={this.state.initialValues.utilityLogic.rates[index].rate}
                                      />
                                      <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          this.removeRatesRow(index);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTrashAlt} color="red" />
                                      </span>
                                      <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          this.addRatesRow();
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPlus} />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner"></div>
                                </>
                              ))}
                            </>
                          )}


                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_7" />
                          </div>

                        </div>

                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button
                            className="add_button"
                            type="button"
                            onClick={(e) => {
                              console.log(values, "nn");
                              this.addUtilityDetails(values);
                            }}
                          >
                            Add
                          </button>
                          <button
                            className="reset_button"
                            type="reset"
                            onClick={(e) => {
                              console.log(values, "nn");
                              this.resetUtilityDetails(values);
                            }}
                          >
                            Reset
                          </button>
                        </div>

                        <div className="utilities">
                          {this.mainFormValidator.message(
                            "Utility details",
                            this.countError,
                            "required",
                            { className: "text-danger" }
                          )}
                          <div className="tableContainer p-0">
                            <table className="table tableSimple tableSimpleWithNoFlex utilityTable">
                              <thead>
                                <tr>
                                  <th scope="col">S.No</th>
                                  <th scope="col">Utility Type</th>
                                  <th scope="col">Utility UOM</th>
                                  <th scope="col">On Area</th>
                                  <th scope="col">Utility Invoice Period</th>
                                  <th scope="col">Applicable From</th>
                                  <th scope="col">Due Date</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.utilities.map(function (name, index) {
                                  return (
                                    <tr key={"utilityTable" + index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <a
                                          className="popupLink"
                                          onClick={(e) => {
                                            this.state.popupData = name;
                                            this.openModal();
                                          }}
                                        >
                                          {name.utility.utilityType}
                                        </a>
                                      </td>
                                      <td>{name.utility.utilityUom}</td>
                                      <td>
                                        {name.utility.onArea == ""
                                          ? "-"
                                          : name.utility.onArea}
                                      </td>
                                      <td>{name.utility.invoicePeriod}</td>
                                      <td>
                                        {name.utility.applicableFrom}(
                                        {leaseDateFormat(
                                          name.utility.applicableFromDate
                                        )}
                                        )
                                      </td>
                                      <td>
                                        {name.utility.dueDate}
                                        {"-"}
                                        {name.utility.dueType}
                                        {"-"}
                                        {name.utility.dueFrequency}
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-center align-items-center gap-2">
                                          <button
                                            type="button"
                                            className="tableActionEdit rentalEdit"
                                            onClick={(e) => {
                                              this.editUtility(index, values);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPen} />
                                          </button>
                                          {this.state.utilities.length ==
                                            index + 1 && (
                                              <button
                                                type="button"
                                                className="actionDelete rentalDeleteButton"
                                                onClick={(e) => {
                                                  // if (
                                                  //   window.confirm(
                                                  //     "Are you sure you want to delete this period?"
                                                  //   )
                                                  // ) {
                                                  //   var _mf = this.state.utilities;
                                                  //   _mf.splice(index, 1);
                                                  //   console.log(_mf, "new array");
                                                  //   this.setState({
                                                  //     utilities: _mf,
                                                  //   });
                                                  // }

                                                  this.setState({
                                                    delete: true,
                                                    index_val: index,
                                                  });

                                                  this.resetUtilityDetails({})
                                                }}
                                              >
                                                <FontAwesomeIcon icon={faTimes} />
                                              </button>
                                            )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }, this)}
                              </tbody>
                            </table>
                            <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                              <button type="submit" className="add_button">
                                Save Draft
                              </button>
                              <button type="reset" className="reset_button">
                                <Link to="/createlease">
                                  Cancel
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>

                  {/* <Form className="customTabs">
                    <div className="newGridSectionParent">
                      <div className="unitFormContainerNew leaseSection utilities">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Lease Term (YY-MM-DD){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 leaseTermFieldWidth">
                                    <Field
                                      type="text"
                                      name="leaseTermYY"
                                      placeholder="YY"
                                      className="centerPlaceHolder text-center"
                                      value={this.state.leaseTermYY}
                                    />
                                  </div>
                                  <div className="col-sm-2 leaseTermFieldWidth">
                                    <Field
                                      type="text"
                                      name="leaseTermMM"
                                      placeholder="MM"
                                      className="centerPlaceHolder text-center"
                                      value={this.state.leaseTermMM}
                                    />
                                  </div>
                                  <div className="col-sm-2 leaseTermFieldWidth">
                                    <Field
                                      type="text"
                                      name="leaseTermDD"
                                      placeholder="DD"
                                      className="centerPlaceHolder text-center"
                                      value={this.state.leaseTermDD}
                                    />
                                  </div>
                                  <ErrorMessage
                                    name="leaseTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Lease Renewal Term (YY-MM-DD){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 leaseTermFieldWidth">
                                    <Field
                                      type="text"
                                      name="leaseRenewalTermYY"
                                      placeholder="YY"
                                      className="centerPlaceHolder text-center"
                                      value={this.state.renewalLeaseTermYY}
                                      onChange={(e) => {
                                        this.state.renewalLeaseTermYY =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-2 leaseTermFieldWidth">
                                    <Field
                                      type="text"
                                      name="leaseRenewalTermMM"
                                      placeholder="MM"
                                      className="centerPlaceHolder text-center"
                                      value={this.state.renewalLeaseTermMM}
                                      onChange={(e) => {
                                        this.state.renewalLeaseTermMM =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-2 leaseTermFieldWidth">
                                    <Field
                                      type="text"
                                      name="leaseRenewalTermDD"
                                      placeholder="DD"
                                      className="centerPlaceHolder text-center"
                                      value={this.state.renewalLeaseTermDD}
                                      onChange={(e) => {
                                        this.state.renewalLeaseTermDD =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <ErrorMessage
                                    name="leaseRenewalTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="from"
                                      value={this.state.from}
                                    />
                                    <ErrorMessage
                                      name="from"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="to"
                                      value={this.state.to}
                                    />
                                    <ErrorMessage
                                      name="to"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Utility Type
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name="utilityLogic.utilityType"
                                      onChange={(e) => {
                                        handleChange(e);
                                        this.loadUtilityUomValues(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Electricity Basis Units @ Grid Rate"
                                        label="Electricity Basis Units @ Grid Rate"
                                      />
                                      <option
                                        value="Electricity Basis Units @ DG"
                                        label="Electricity Basis Units @ DG"
                                      />
                                      <option
                                        value="Electricity Basis Units @ Solar"
                                        label="Electricity Basis Units @ Solar"
                                      />
                                      <option
                                        value="Electricity Basis Units @ Other Sources"
                                        label="Electricity Basis Units @ Other Sources"
                                      />
                                      <option
                                        value="Electricity Basis Units @ Blendid"
                                        label="Electricity Basis Units @ Blendid"
                                      />
                                      <option
                                        value="Water Basis Units @ Board"
                                        label="Water Basis Units @ Board"
                                      />
                                      <option
                                        value="Water Basis Units @ Other Sources"
                                        label="Water Basis Units @ Other Sources"
                                      />
                                      <option
                                        value="Gas Basis Units @ Gas Bank"
                                        label="Gas Basis Units @ Gas Bank"
                                      />
                                      <option
                                        value="Gas Basis Units @ Piped Gas Bank"
                                        label="Gas Basis Units @ Piped Gas Bank"
                                      />
                                      <option
                                        value="HVAC Basis Flat Unit Rate"
                                        label="HVAC Basis Flat Unit Rate"
                                      />
                                      <option
                                        value="HVAC Basis BTU Unit Rate"
                                        label="HVAC Basis BTU Unit Rate"
                                      />
                                      <option
                                        value="Extra Hours Charges Basis Flat Rate"
                                        label="Extra Hours Charges Basis Flat Rate"
                                      />
                                      <option
                                        value="Horticulture Charges Flat Rate"
                                        label="Horticulture Charges Flat Rate"
                                      />
                                      <option
                                        value="MEP Services Flat Rate"
                                        label="MEP Services Flat Rate"
                                      />
                                      <option
                                        value="CAM During Fitout Period"
                                        label="CAM During Fitout Period"
                                      />
                                      <option value="Other" label="Other" />
                                    </Field>
                                    {this.validator.message(
                                      "utility Type",
                                      values.utilityLogic.utilityType,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Utility UOM
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name="utilityLogic.utilityUom"
                                      onChange={(e) => {
                                        this.validator = new SimpleReactValidator({
                                          autoForceUpdate: this,
                                        });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      {this.state.utilityRateUomValues.map(
                                        (item, i) => (
                                          <option
                                            key={"utilityRateUomValues" + item}
                                            value={item}
                                          >
                                            {item}
                                          </option>
                                        )
                                      )}
                                    </Field>
                                    {this.validator.message(
                                      "Utility UOM",
                                      values.utilityLogic.utilityUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.utilityLogic.utilityUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      on Area
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"utilityLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.utilityLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Utility Invoice Period
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name="utilityLogic.invoicePeriod"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Day"
                                        label="Per Day"
                                      ></option>
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      ></option>
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      ></option>
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      ></option>
                                    </Field>
                                    {this.validator.message(
                                      "Utility Invoice Period",
                                      values.utilityLogic.invoicePeriod,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Applicable From
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name="utilityLogic.applicableFrom"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Fitout Letter Date"
                                        label="Fitout Letter Date"
                                      ></option>
                                      <option
                                        value="Lease Commencement Date"
                                        label="Lease Commencement Date"
                                      ></option>
                                      <option
                                        value="Rent Commencement Date"
                                        label="Rent Commencement Date"
                                      ></option>
                                      <option
                                        value="Other Date"
                                        label="Other Date"
                                      ></option>
                                    </Field>
                                    {this.validator.message(
                                      "Applicable From",
                                      values.utilityLogic.applicableFrom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Due Date <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name={"utilityLogic.dueDate"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      name={"utilityLogic.dueType"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      name={"utilityLogic.dueFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Due Date",
                                      values.utilityLogic.dueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Applicable From Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="utilityLogic.applicableFromDate"
                                    />
                                    {this.validator.message(
                                      "Applicable From",
                                      values.utilityLogic.applicableFromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.utilityLogic.utilityType == "Other" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Sub Category Type
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="utilityLogic.subCategoryTypes"
                                      />
                                      <ErrorMessage
                                        name="utilityLogic.subCategoryTypes"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="unitFormContainerNew leaseSection utilities rates mt-0">
                        <div className="row m-0">
                          {this.state.showFirstAddBtn == true && (
                            <div className="col-lg-12 p-0 text-end">
                              <div className="button_group">
                                <button
                                  type="button"
                                  className="add_button"
                                  onClick={(e) => {
                                    this.addRatesRow();
                                  }}
                                >
                                  Add Rates
                                </button>
                              </div>
                            </div>
                          )}
                          {this.state.initialValues.utilityLogic.rates !=
                            undefined && (
                              <div className="col-lg-12 mx-auto p-0">
                                <hr />
                                {this.state.initialValues.utilityLogic.rates.map(
                                  (name, index) => (
                                    <div className="row m-0 mb-3 justify-content-between align-items-center">
                                      <div className="col-7 ps-0">
                                        <div className="row m-0">
                                          <div className="col-6 ps-0">
                                            <div className="row m-0">
                                              <label className="col-sm-2 ps-0 col-form-label">
                                                From
                                              </label>
                                              <div className="col-sm-10 pe-0">
                                                <Field
                                                  type="date"
                                                  name={`utilityLogic.rates.${index}.from`}
                                                  onChange={(e) => {
                                                    this.state.initialValues.utilityLogic.rates[
                                                      index
                                                    ].from = e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  value={
                                                    this.state.initialValues
                                                      .utilityLogic.rates[index].from
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 pe-0">
                                            <div className="row m-0">
                                              <label className="col-sm-2 ps-0 col-form-label">
                                                To
                                              </label>
                                              <div className="col-sm-10 pe-0">
                                                <Field
                                                  type="date"
                                                  name={`utilityLogic.rates.${index}.to`}
                                                  onChange={(e) => {
                                                    this.state.initialValues.utilityLogic.rates[
                                                      index
                                                    ].to = e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  value={
                                                    this.state.initialValues
                                                      .utilityLogic.rates[index].to
                                                  }
                                                  onBlur={(e) => {
                                                    if (
                                                      index <
                                                      this.state.initialValues
                                                        .utilityLogic.rates.length -
                                                      1
                                                    ) {
                                                      this.getFromForNextSlab(
                                                        e,
                                                        values,
                                                        index
                                                      );
                                                    }
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-4 pe-0">
                                        <div className="row m-0">
                                          <label className="col-sm-2 ps-0 col-form-label">
                                            Rate
                                          </label>
                                          <div className="col-sm-10 pe-0 d-flex gap-2 align-items-center">
                                            <Field
                                              type="text"
                                              name={`utilityLogic.rates.${index}.rate`}
                                              onChange={(e) => {
                                                this.state.initialValues.utilityLogic.rates[
                                                  index
                                                ].rate = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .utilityLogic.rates[index].rate
                                              }
                                            />
                                            <span style={{ cursor: 'pointer' }}
                                              onClick={(e) => {
                                                this.removeRatesRow(index);
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faTrashAlt} color="red" />
                                            </span>
                                            <span style={{ cursor: 'pointer' }}
                                              onClick={(e) => {
                                                this.addRatesRow();
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faPlus} />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-12 p-0">
                                        <div className="button_group">
                                          <button className="add_button" onClick={(e) => {
                                            this.addRatesRow();
                                          }}>
                                            Add Rates
                                          </button>
                                        </div>
                                      </div>
                                      <div className="col-lg-3">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">
                                              From
                                            </label>
                                            <div className="col-sm-10">
                                              <Field
                                                type="date"
                                                name={`utilityLogic.rates.${index}.from`}
                                                onChange={(e) => {
                                                  this.state.initialValues.utilityLogic.rates[
                                                    index
                                                  ].from = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .utilityLogic.rates[index].from
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-3">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">
                                              To
                                            </label>
                                            <div className="col-sm-10">
                                              <Field
                                                type="date"
                                                name={`utilityLogic.rates.${index}.to`}
                                                onChange={(e) => {
                                                  this.state.initialValues.utilityLogic.rates[
                                                    index
                                                  ].to = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .utilityLogic.rates[index].to
                                                }
                                                onBlur={(e) => {
                                                  if (
                                                    index <
                                                    this.state.initialValues
                                                      .utilityLogic.rates.length -
                                                    1
                                                  ) {
                                                    this.getFromForNextSlab(
                                                      e,
                                                      values,
                                                      index
                                                    );
                                                  }
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-3">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">
                                              Rate
                                            </label>
                                            <div className="col-sm-10">
                                              <Field
                                                type="text"
                                                name={`utilityLogic.rates.${index}.rate`}
                                                onChange={(e) => {
                                                  this.state.initialValues.utilityLogic.rates[
                                                    index
                                                  ].rate = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .utilityLogic.rates[index].rate
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-3">
                                        <span
                                          className="ratesAdd me-2"
                                          onClick={(e) => {
                                            this.addRatesRow();
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faPlus} />
                                        </span>
                                        <span
                                          className="ratesRemove"
                                          onClick={(e) => {
                                            this.removeRatesRow(index);
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </span>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="unitFormContainerNew">
                        <span className="remarks">Notes/Remarks</span>
                        <Field as="textarea" className="notes mb-3" name="notes_7" />
                      </div>
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          className="add_button"
                          type="button"
                          onClick={(e) => {
                            console.log(values, "nn");
                            this.addUtilityDetails(values);
                          }}
                        >
                          Add
                        </button>
                        <button
                          className="reset_button"
                          type="reset"
                          onClick={(e) => {
                            console.log(values, "nn");
                            this.resetUtilityDetails(values);
                          }}
                        >
                          Reset
                        </button>
                      </div>

                      <div className="utilities">
                        {this.mainFormValidator.message(
                          "Utility details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple tableSimpleWithNoFlex utilityTable">
                            <thead>
                              <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Utility Type</th>
                                <th scope="col">Utility UOM</th>
                                <th scope="col">On Area</th>
                                <th scope="col">Utility Invoice Period</th>
                                <th scope="col">Applicable From</th>
                                <th scope="col">Due Date</th>
                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.utilities.map(function (name, index) {
                                return (
                                  <tr key={"utilityTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        className="popupLink"
                                        onClick={(e) => {
                                          this.state.popupData = name;
                                          this.openModal();
                                        }}
                                      >
                                        {name.utility.utilityType}
                                      </a>
                                    </td>
                                    <td>{name.utility.utilityUom}</td>
                                    <td>
                                      {name.utility.onArea == ""
                                        ? "-"
                                        : name.utility.onArea}
                                    </td>
                                    <td>{name.utility.invoicePeriod}</td>
                                    <td>
                                      {name.utility.applicableFrom}(
                                      {leaseDateFormat(
                                        name.utility.applicableFromDate
                                      )}
                                      )
                                    </td>
                                    <td>
                                      {name.utility.dueDate}
                                      {"-"}
                                      {name.utility.dueType}
                                      {"-"}
                                      {name.utility.dueFrequency}
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-center align-items-center gap-2">
                                        <button
                                          type="button"
                                          className="tableActionEdit rentalEdit"
                                          onClick={(e) => {
                                            this.editUtility(index, values);
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        {this.state.utilities.length ==
                                          index + 1 && (
                                            <button
                                              type="button"
                                              className="actionDelete rentalDeleteButton"
                                              onClick={(e) => {
                                                // if (
                                                //   window.confirm(
                                                //     "Are you sure you want to delete this period?"
                                                //   )
                                                // ) {
                                                //   var _mf = this.state.utilities;
                                                //   _mf.splice(index, 1);
                                                //   console.log(_mf, "new array");
                                                //   this.setState({
                                                //     utilities: _mf,
                                                //   });
                                                // }

                                                this.setState({
                                                  delete: true,
                                                  index_val: index,
                                                });

                                                this.resetUtilityDetails({})
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                          )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }, this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form> */}
                </>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row">
                        <div className="col-lg-12">
                          <ul>
                            <li>Utility Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.utilityPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  utilityPopup(utility) {
    return this.utilityDetailsPopup(utility);
  }
  utilityDetailsPopup(utility) {
    console.log(utility.utility.rates);
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Utility Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {utility.utility.utilityType}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Utility UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {utility.utility.utilityUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Utility Invoice Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {utility.utility.invoicePeriod}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Utility Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {utility.utility.dueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Applicable From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {utility.utility.applicableFrom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Applicable From Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(
                    utility.utility.applicableFromDate,
                    "dd mmm yyyy"
                  )} */}
                  {leaseDateFormat(utility.utility.applicableFromDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        {utility.utility.utilityType == "Other" && (
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Sub Category Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {utility.utility.subCategoryTypes}
                </label>
              </div>
            </div>
          </div>
        )}
        {utility.utility.rates != undefined &&
          utility.utility.rates.map(function (name, index) {
            return (
              <div className="row rateRow">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-5 col-form-label">
                        From <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {leaseDateFormat(name.from)}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-5 col-form-label">
                        To <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {leaseDateFormat(name.to)}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-5 col-form-label">
                        Rate <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {name.rate}
                      </label>
                    </div>
                  </div>
                </div>


              </div>
            );
          }, this)}
      </div>
    );
  }
}

export default withRouter(Utilities);
